import React, { useMemo } from 'react'
import placeholderImg from '../../../../../../../assets/images/placeholder.jpg'
import { AiOutlineLike } from "react-icons/ai";
import { FiMessageCircle } from "react-icons/fi";
import { BsArrowReturnRight } from "react-icons/bs";
import PostComments from '../../PostComments';
import usePostApi from '../../../../../../../config/hooks/api/post/usePostApi';
import { Tag } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import imgPlaceholder from '../../../../../../../assets/images/img-placeholder-small.jpg'

const SharedPostContent = ({ data, refreshFeed }) => {
    const navigate = useNavigate()
    const { likeDislikePost } = usePostApi()

    const location = useLocation()

    const contentData = useMemo(() => ({
        imageUrl: (!data?.originalPost && data?.shareDescription) ? imgPlaceholder : data?.imageUrl,
        description: data?.originalPost ? data?.originalPost?.description : data?.description,
        reactions: {
            likeCount: data?.originalPost ? data?.originalPost?.likeCount : data?.likeCount,
            shareCount: data?.originalPost ? data?.originalPost?.shareCount : data?.shareCount,
            commentCount: data?.originalPost ? data?.originalPost?.commentCount : data?.commentCount
        }
    }), [data]);

    const handleReaction = async () => {
        try {
            if (data && data?.id && data?.type) {
                const response = await likeDislikePost(data?.id)
                if (response) refreshFeed()
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <React.Fragment>
            {data && contentData && (
                <div className='mb-2 content'>
                    <div className='post'>
                        <p className='text-black mb-4'>
                            {contentData?.description}
                        </p>
                        {/* case1: for shared post with image*/}
                        {/* case2: for shared post without image*/}
                        {/* case3: for shared post with original post deleted*/}
                        {/* case4: for share post preview */}
                        {(data?.originalPost && data?.shareDescription) && data?.imageUrl ? (
                            <div className='cover mb-4'>
                                <img
                                    src={
                                        data?.imageUrl ? data?.imageUrl :
                                            data?.imageUrl.includes('null') ? placeholderImg :
                                                ''
                                    }
                                    alt='post cover'
                                    className='img-fluid'
                                />
                            </div>
                        ) : (data?.originalPost && data?.shareDescription) && !data?.imageUrl ? ''
                            : !data?.originalPost && data?.shareDescription ? (
                                <div className='mb-4 border flex justify-center items-center p-8 bg-[#c5c3c4]'>
                                    <div className='flex items-center flex-col'>
                                        <img src={imgPlaceholder} alt='post cover' className='img-fluid' style={{ width: '70%' }} />
                                        <h5 className='heading-5 font-semibold'>Post deleted by owner</h5>
                                    </div>
                                </div>
                            ) : (!data?.originalPost && !data?.shareDescription) && data?.imageUrl ? (
                                <div className='cover mb-4'>
                                    <img
                                        src={data?.imageUrl}
                                        alt='post cover'
                                        className='img-fluid'
                                    />
                                </div>
                            ) : ''}
                        {data?.originalPost && data?.originalPost.hashTags && data?.originalPost.hashTags.length ? (
                            <PostHashtags data={data?.originalPost} />
                        ) : ''}
                    </div>

                    {/* if not a shared post */}
                    {!data?.originalPost && (
                        <React.Fragment>
                            <div className='flex justify-start items-center post-reactions mb-2'>
                                <div className='flex items-center like'>
                                    <AiOutlineLike className='icon' onClick={handleReaction} />
                                    <small className='text-xs font-semibold'>{contentData?.reactions?.likeCount}</small>
                                </div>
                                <div className='flex items-center ml-6 comment'>
                                    <FiMessageCircle className='icon' />
                                    <small className='text-xs font-semibold'>{contentData?.reactions?.commentCount}</small>
                                </div>
                                {location && !location?.pathname.toLowerCase().includes('share') && (
                                    <div className='flex items-center ml-6 share'>
                                        <BsArrowReturnRight
                                            className='icon'
                                            // onClick={handlePostShare} 
                                            onClick={() => navigate(`/post/share/${(data?.originalPost && data?.shareDescription) ?
                                                    data?.originalPost.id :
                                                    data?.id
                                                }`)}
                                        />
                                        <small className='text-xs font-semibold'>{contentData?.reactions?.shareCount}</small>
                                    </div>
                                )}
                            </div>

                            {data?.hashTags && data.hashTags.length ? (
                                <PostHashtags data={data} />
                            ) : ''}
                            {location && !location?.pathname.toLowerCase().includes('share') && (
                                <PostComments data={data} refreshFeed={refreshFeed} />
                            )}
                        </React.Fragment>
                    )}
                </div>
            )}
            {/* <Modal.Basic open={openShareModal} onCancel={closeModal} width={400}>
                <PostShare postId={data?.id} closeModal={closeModal} refreshFeed={refreshFeed}/>
            </Modal.Basic> */}
        </React.Fragment>
    )
}

export default SharedPostContent


const PostHashtags = ({ data }) => {
    const navigate = useNavigate()

    return (
        <div className='hashtags'>
            {/* <hr className={`border-dashed border-1 border-gray-200 mb-4 mt-0`} /> */}
            <hr className={`border-dashed border-1 border-gray-200 mb-2 mt-2`}
            />
            <div className='flex items-center mb-2'>
                {data?.hashTags.map(item => (
                    <Tag 
                        color="#FAB70040" 
                        className='cursor-pointer' 
                        onClick={() => navigate(`../posts/${item.tag}`)}
                        key={item.tag}
                    >
                        <small className='text-black font-bold'>#{item.tag}</small>
                    </Tag>
                ))}
            </div>
            <hr className={`border-dashed border-1 border-gray-200 mb-4 mt-0`} />
        </div>
    )
}
